export default {
  es: {
    'app.ventas.form.err.tipos_inmuebles_id': 'Es necesario seleccionar la promoción y el tipo de inmueble vendido',
    'app.ventas.form.err.visita': 'Es necesario asociar una visita a la venta',
    'app.ventas.form.modal.close': 'Cerrar',
    'app.ventas.form.modal.title': 'Seleccione una visita',
    'app.ventas.form.promociones': 'Promoción',
    'app.ventas.form.save': 'Guardar',
    'app.ventas.form.submit.success': 'La venta se ha guardado correctamente',
    'app.ventas.form.title-anadir': 'Añadir nueva venta',
    'app.ventas.form.visita': 'Visitas',
    'app.ventas.index.column.created_at': 'Fecha de creación',
    'app.ventas.index.column.name': 'Comprador',
    'app.ventas.index.column.promocion': 'Promoción',
    'app.ventas.index.nuevo': 'Añadir venta',
    'app.ventas.index.title': 'Listado de ventas',
    'app.ventas.index.no-results': 'No existen ventas en la base de datos'
  },
};